import axios from "axios";
import { getToken, logout } from "@/api/auth/token";

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = token;
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      logout();
      window.location.reload();
    }
    if (err?.response?.data) {
      err.message = JSON.stringify(err.response.data);
    }
    return Promise.reject(err);
  },
);
